import React, { memo, useCallback } from 'react';
import { Link } from 'js/components/common/Link';
import { Icon } from 'js/components/common/Icon';
import { usePortletDispatch, usePortletTranslations } from 'js/components/system/Portlet';
import { setExpandedCategoryAction } from '../actions';
import style from './index.scss';

export const ViewMore = ({ expanded, cid }) => {
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();
    const onClick = useCallback((event) => {
        event.preventDefault();

        dispatch(setExpandedCategoryAction(cid));
    }, [cid, dispatch]);

    return <Link href="#" className={style.toggleAllGames} onClick={onClick}>
        {t(`games.${expanded ? 'viewLess' : 'viewMore'}`)}
        <Icon type="showMoreArrow" className={style.icon} />
    </Link>;
};

export const ViewMoreWithExpanded = memo(ViewMore, (p, n) => p.expanded === n.expanded);
